
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 47 47","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M23.5 1C11.073 1 1 11.074 1 23.498 1 35.926 11.073 46 23.5 46S46 35.926 46 23.498C46 11.074 35.927 1 23.5 1z","stroke":"#515358"}}),_c('svg',{attrs:{"viewBox":"0 0 34 34","fill":"#515358","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M23 16h-3.18c-.42-1.16-1.52-2-2.82-2-1.3 0-2.4.84-2.82 2H11c-.33 0-2-.1-2-2v-1c0-1.83 1.54-2 2-2h10.18c.42 1.16 1.52 2 2.82 2a3 3 0 003-3 3 3 0 00-3-3c-1.3 0-2.4.84-2.82 2H11c-1.61 0-4 1.06-4 4v1c0 2.94 2.39 4 4 4h3.18c.42 1.16 1.52 2 2.82 2 1.3 0 2.4-.84 2.82-2H23c.33 0 2 .1 2 2v1c0 1.83-1.54 2-2 2H12.82c-.42-1.16-1.52-2-2.82-2a3 3 0 00-3 3 3 3 0 003 3c1.3 0 2.4-.84 2.82-2H23c1.61 0 4-1.07 4-4v-1c0-2.93-2.39-4-4-4m1-7a1 1 0 011 1 1 1 0 01-1 1 1 1 0 01-1-1 1 1 0 011-1M10 25a1 1 0 01-1-1 1 1 0 011-1 1 1 0 011 1 1 1 0 01-1 1z"}})])])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/bulk_tp.svg